import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  display: grid;
  grid-template-rows: 25px 1fr;
  text-align: center;
  height: 100%;
  overflow-y: hidden;
`
export const LoadingContainer = styled.div`
  height: 100%;
  justify-content: center;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const Contents = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  padding: 5px;
  text-align: left;
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  height: 100%;

  ul {
    li {
      strong {
        font: normal normal bold 12px/22px Inter;
      }
      margin-left: 4px;
      font: normal normal normal 12px/22px Inter;
    }
  }

  overflow-y: auto;

  ${VerticalStyledScrollBar}
`

export const AlertMessage = styled.div`
  width: 100%;
  height: 100%;
  padding: 5px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: ${props => props.theme.colors.color6b7786};
    font-family: Inter;
    font-size: 12px;
    font-weight: 22px;
    text-align: center;
  }
`
